export function routes($stateProvider) {
  $stateProvider
    .state('app.formacao', {
      url: '/formacao',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.formacao.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Formações',
      template: require('./directory/directory.view.html'),
      controller: 'FormacaoListController',
      controllerAs: 'vm',
      role: 'formacaoRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "asc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.formacao.details', {
      url: '/{id}',
      title: 'Formação',
      controller: 'FormacaoDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'formacaoRead'
    })
  ;
}

routes.$inject = ['$stateProvider'];
